import {Component, Input, OnInit} from '@angular/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Observable} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {MenuItem} from '../../../../interfaces/data.interfaces';
import {SettingsService} from '../../../../../services/settings.service';
import {UserTypeEnum} from '../../../../interfaces/data.interfaces';
import {StorageService} from '../../../../../services/storage-service.service';
import {MenuService} from '../../../../../services/menu.service';
import {Location} from '@angular/common';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-staff-layout',
    templateUrl: './staff-layout.component.html',
    styleUrls: ['./staff-layout.component.scss'],
    standalone: false
})
export class StaffLayoutComponent implements OnInit{
  userType : string;
  mainMenu: MenuItem[];
  @Input() moduleTitle: string;
  @Input() moduleMenu: MenuItem[];
  @Input() moduleIconType: 'SVG' | 'MATERIAL';
  @Input() moduleIconTitle: string;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
  loggedInUserType: UserTypeEnum;

  // Lazy-loaded module chunks can take a moment to download on a slow
  // connection, during which nothing visibly changes after clicking a
  // sidebar link — this flag drives a top progress bar so the click
  // registers immediately instead of looking unresponsive.
  navigating = false;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private settingsService: SettingsService,
    private menuService: MenuService,
    private storageService: StorageService,
    private location: Location,
    private route: Router,
  ) {
    this.loggedInUserType = this.storageService.get('category');
  }

  ngOnInit() {
    this.userType  = this.storageService.get('userType');
    this.mainMenu = this.menuService.mainMenu;
    console.log(this.mainMenu,"this are the all the menu");

    this.route.events.pipe(
      filter(event =>
        event instanceof NavigationStart ||
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      )
    ).subscribe(event => {
      this.navigating = event instanceof NavigationStart;
    });
  }
    goBack() {
   this.route.navigate(['', 'dashboard']);
  }
}
